import React, { useContext, useState } from "react";
import { Context } from "../../../Utility/ContextManager";
import { formatPhoneNumber } from "../../../Utility/index";
import { Modal, Button, Card, Row, Col } from "react-bootstrap";
import envFile from "../../../envFile";

function RentersInsurance(props) {
  const { isMember } = props;
  const { propertyManagerInfo } = useContext(Context);
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  // const handleShow = () => {
  //   //redirect to the renters insurance page
  //   window.open(`${envFile.SUREAPP_API_LINK}/product/renters-insurance/?embed=true`, "_blank");
  // };
  const handleClose = () => setShowModal(false);

  return (
    <div className="details mx-2" style={{ minHeight: "160px", position: "relative" }}>
      <Row>
        <Col xl={1} xs={2} sm={1} className="d-flex align-items-start justify-content-start p-1">
          <img
            width={75}
            height={75}
            className="d-flex align-items-start justify-content-start my-5 mx-0"
            src={require("../../../assets/images/lock-icon-green.svg").default}
            alt="Success Icon"
          />
        </Col>
        <Col xl={9} xs={10} sm={10} className="d-flex justify-content-start mt-4 mt-md-0">
          <div>
            <p
              style={{
                color: "#1a5e61",
                fontSize: "1.4rem",
                lineHeight: "35px",
                fontWeight: "bold", // Ensure this line is bold
                margin: "0", // Remove default margin
              }}
              className="fw-bold my-1 d-flex justify-content-start text-start mx-0 mx-lg-2 mx-xxl-3 mx-xl-4 mt-3 mt-xl-3 mt-sm-0"
            >
              {isMember ? (
                <>
                  Secure Peace
                  <br />
                  of Mind
                </>
              ) : (
                <>
                  Protect your
                  <br />
                  Personal Property
                </>
              )}
            </p>
            <p
              style={{
                color: "#000", // Set text color to black
                fontSize: "1.2rem",
                lineHeight: "35px",
                fontWeight: "normal", // Ensure this line is not bold
                margin: "0", // Remove default margin
              }}
              className="my-1 d-flex justify-content-start text-start mx-0 mx-lg-2 mx-xxl-3 mx-xl-4"
            >
              {isMember ? (
                <>
                  Purchase a Home
                  <br />
                  Warranty Today!
                </>
              ) : (
                <>
                  Purchase Renter’s
                  <br />
                  Insurance Today!
                </>
              )}
            </p>
          </div>
        </Col>
        <Col xl={2} xs={2} sm={1} className="d-flex align-items-start justify-content-start">
          {/* Button positioned absolutely */}
          <div
            style={{
              position: "absolute",
              top: "0px",
              right: "0px",
              width: "auto",
              height: "auto",
            }}
          >
            <button
              className="d-flex align-items-center"
              style={{
                height: "2.4rem",
                backgroundColor: "#9BD5C3",
                borderColor: "#1A5E61",
                color: "#1A5E61",
                borderRadius: "15px",
                border: "2px solid #1A5E61",
                fontSize: "1.2rem",
                cursor: "pointer",
              }}
              onClick={handleShow}
            >
              Learn More
            </button>
          </div>
        </Col>
      </Row>
      <Modal show={showModal} onHide={handleClose} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {isMember ? "Home Warranty" : "Renters Insurance"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={`${envFile.SUREAPP_API_LINK}/product/${isMember ? "home-warranty" : "renters-insurance"}/?embed=true`}
            style={{ width: "100%", height: "80vh", border: "0" }}
            title="Renters Insurance"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RentersInsurance;
